(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('HelpController', HelpController);

  /* ngInject */
  function HelpController(config) {
    const vm = this;

    vm.config = config;
  }
})();
